import { Form, Modal } from "antd";
import lang from "../helper/langHelper";

const DeleteModal = ({ show, hide, onOk, title, subtitle }) => {

  return (
    <Modal
      width={700}
      open={show}
      onOk={() => {
        if (onOk) onOk();
        hide();
      }}
      okText={lang("Ok")}
      cancelText={lang("Cancel")}
      onCancel={hide}
      centered
      className="tab_modal deleteWarningModal"
    >
      <Form layout="vertical" className="p-2">
        <h4 className="modal_title_cls mb-2">{title}</h4>
        <h4
          className="modal_sub_title_cls mt-4"
          style={{ fontSize: "18px", color: "black" }}
        >
          {subtitle}
        </h4>
      </Form>
    </Modal>
  );
};

export default DeleteModal;
